import { createSlice } from '@reduxjs/toolkit';
import { getBatchDefinitionsList } from 'ducks/batch-definition-list/operators';
import { Slices } from 'ducks/slices';
import { BatchDefinitionsListAPI } from 'ducks/types/api-types';

export type BatchDefinitionListState = BatchDefinitionsListAPI[];

const initialState: BatchDefinitionListState = [];

const batchDefinitionListSlice = createSlice({
  name: Slices.BATCH_DEFINITION_LIST,
  initialState,
  reducers: {
    clearBatchDefinition: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBatchDefinitionsList.pending, () => {
        return initialState;
      })
      .addCase(getBatchDefinitionsList.fulfilled, (_, { payload }) => {
        return payload;
      })
      .addCase(getBatchDefinitionsList.rejected, () => {
        return initialState;
      });
  },
});

export const { clearBatchDefinition } = batchDefinitionListSlice.actions;

export default batchDefinitionListSlice.reducer;
